import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';

import { SecurityService } from '../_services/security.service';
import { NavigationService } from '../_services/navigation.service';
import { SecurityResponse } from '../_models/security-response.model';

@Injectable()
export class JwtAuthTransporteurGuard implements CanActivate {
  
  constructor(private securityService: SecurityService, private router: Router, private naivgationService: NavigationService) { }
  
  canActivate(): Observable<boolean> {
    return this.securityService.verifyToken().switchMap((res: SecurityResponse) => {
      if (res && res.token && res.user && (res.user.is_seller || res.user.is_admin)) {
        return Observable.of(true);
      }
      return Observable.of(false);
    }).do(isAuthorized => {
      if (!isAuthorized) {
        this.naivgationService.resetNavigation();
        this.router.navigate(['/login']);
        return Observable.of(false);
      }
    }).catch(() => {
      this.naivgationService.resetNavigation();
      this.router.navigate(['/login']);
      return Observable.of(false);
    });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_guards/jwt-auth-transporteur.guard.ts